export const twoColumnATS = {
  id: 'two-column-ats',
  version: 2,
  renderer: 'enterprise',
  name: 'Two Column ATS',
  layout: 'two-column',
  theme: 'slate-executive',
  persona: ['software', 'backend', 'engineering'],
  atsLevel: 'A',
  scoreWeights: {
    ats: 45,
    visual: 30,
    executive: 15,
    student: 10
  },
  sectionOrder: ['personal-info', 'summary', 'experience', 'projects', 'education', 'skills', 'languages'],
  components: {
    header: 'header-classic',
    experience: 'experience-classic',
    projects: 'projects-list',
    skills: 'skills-sidebar',
    education: 'education-sidebar'
  },
  metadata: {
    industry: ['Tech Startups', 'SaaS Companies', 'Corporate IT'],
    companies: ['Google', 'Microsoft', 'Amazon', 'Atlassian', 'Stripe', 'Figma'],
    ats: ['Greenhouse', 'Lever', 'Workday'],
    pages: { min: 1, max: 2, preferred: 1 },
    photo: false,
    icons: false,
    density: 'comfortable',
    columns: 2,
    experienceLevel: ['Entry-level', 'Mid-level', 'Senior'],
    careerStage: 'Professional',
    recommendedFor: ['Full Stack Developers', 'DevOps Specialists', 'Systems Engineers'],
    avoidFor: ['Investment Bankers', 'Academic Researchers', 'Creative Writers'],
    dna: ['Two-Column-ATS', 'Structured-Sidebar', 'Balanced-Whitespace', 'Inter-Sans', 'Corporate-Modern'],
    metrics: {
      readingDifficulty: 92,
      scanningSpeed: 94,
      visualAppeal: 92
    },
    hiringManager: {
      firstImpression: "Clean, structured technical professional with strong skills summary",
      scanningStyle: "Two-column F-Pattern scan focusing on sidebar skills, then main body experience",
      preferredStructure: "Summary and experience in main body; education, skills, and languages in sidebar",
      dislikes: ["Objective statements", "Visual ratings bars", "Lack of project technical stack info"]
    },
    strategy: {
      goal: "Provide a balanced two-column format that parses perfectly in tech ATS systems",
      focus: "Sidebar skills keyword matching, project technical details, and experience metrics",
      avoid: ["Gimmicky design tokens", "Unformatted graphics"]
    },
    psychology: {
      coreTraits: ["Efficiency", "Technical versatility", "Structure", "Innovation"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: false,
      sidebar: true
    },
    aiPrompt: {
      writingStyle: "Start bullets with action verbs. Include tech stack keywords in sidebar. Keep main body description metric-driven.",
      rewriteStyle: "Tech-focused, structured, concise"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9.5pt",
      lineHeight: 1.45,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'two-column': {
      component: 'two-column',
      slots: {
        header: ['personal-info'],
        sidebar: ['education', 'skills', 'languages'],
        main: ['summary', 'experience', 'projects']
      },
      overrides: {
        '--layout-sidebar-width': '197px',
        '--layout-column-gap': '20px'
      }
    }
  },
  styleOverrides: {
    '--font-size-display': '26pt',
    '--weight-display': '800',
    '--heading-text-transform': 'none',
    '--heading-weight': '600',
    '--border-thickness-heading': '2px',
    '--bullet-style': 'disc',
    '--spacing-section-mb': '18px',
    '--spacing-item-mb': '12px',
    '--spacing-bullet-gap': '5px',
    '--color-text-main': '#2D3748',
    '--color-text-light': '#718096'
  }
};
export default twoColumnATS;
